var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharePositionReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1256 0.492847L15.5944 7.67318L13.147 5.66974C10.4493 6.83441 9.00219 8.87391 8.9261 11.5158C6.44279 7.91226 7.89404 4.78422 10.6499 2.70465L8.98698 0.400688L16.1256 0.492847ZM3.9152 0H5.92952V2.62718H4.51977C3.94287 2.62718 3.41854 2.85557 3.0367 3.22421C2.65625 3.5915 2.41968 4.09904 2.41968 4.656L2.41553 10.7999C2.41968 11.3555 2.65763 11.8617 3.03808 12.2303C3.41992 12.599 3.94564 12.8287 4.51977 12.8287H12.5466C13.1208 12.8287 13.6465 12.599 14.0283 12.2303C14.4102 11.8617 14.6481 11.3555 14.6481 10.7999V9.87029H17.0014V11.3836C17.0014 12.4213 16.5587 13.6595 15.8503 14.3433C15.142 15.0271 14.1611 15.4545 13.0862 15.4545H3.9152C2.84025 15.4545 1.85937 15.0271 1.15104 14.3433C0.441325 13.6581 0 12.7125 0 11.6747L0.00415039 3.78116C0 2.74071 0.441325 1.79375 1.14966 1.10991C1.85799 0.426065 2.83748 0 3.9152 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15.4545,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePositionReport);
export default __webpack_public_path__ + "static/media/share-position-report.c05f7fe8b2e691c73123f260585d966d.svg";
export { ForwardRef as ReactComponent };